<template>
    <transition name="add_methods">
        <div class="modal_background" v-if="dialog">
            <div class="modal_add_methods_wrap">
                <div class="flex flex-column">
                    <h1 class="header">Create method</h1>
                    <v-text-field
                        v-model="createMethodParams.name"
                        label="Method Name"
                        class="method_name_input"
                    ></v-text-field>
                    <v-text-field
                        v-model="createMethodParams.minimum"
                        label="Minimum Amount"
                        type="number"
                    ></v-text-field>
                    <v-switch v-model="createMethodParams.tipalti" label="Tipalti"></v-switch>
                    <v-row>
                        <v-col cols="6">
                            <v-switch v-model="createMethodParams.is_on_dashboard_enabled" label="Dashboard Enabled"></v-switch>
                        </v-col>
                        <v-col cols="6">
                            <v-switch v-model="createMethodParams.is_on_funnel_enabled" label="Funnel Enabled"></v-switch>
                        </v-col>
                    </v-row>
                    <div class="button-row">
                        <v-btn @click="dialog = !dialog" class="btn">Cancel</v-btn>
                        <v-btn
                                class="btn"
                                v-if="!loading"
                                color="primary"
                                @click="createMethod"
                                :disabled="!createMethodValidation"
                                :class="{disabled_btn: !createMethodValidation}"
                        >
                            Create
                        </v-btn>
                        <v-progress-circular
                        class="progress-absolute"
                        v-else
                        indeterminate
                        color="primary"
                        size="50"
                        ></v-progress-circular>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapActions, mapGetters, mapState } from "vuex";
    import store from "@/store";
    import { getCookie } from "@/helpers";

    export default {
        name: "NewMethod",
        props: {
            open: {
                type: Boolean,
                default: false
            },
        },
        model: {
            prop: 'open',
            event: 'toggle'
        },
        data() {
            return {
                loading: false,
                dialog: this.open,
                createMethodParams: {
                    name: '',
                    minimum: '',
                    tipalti: false,
                    is_on_dashboard_enabled: false,
                    is_on_funnel_enabled: false,
                },
            }
        },
        computed: {
            ...mapState('user', ['user']),
            createMethodValidation() {
                return this.createMethodParams.name && (Number(this.createMethodParams.minimum) !== 0)
            }
        },
        async mounted() {
            this.dialog = this.open;
        },

        methods: {
            ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
            async createMethod() {
                this.loading = true;

                console.log(this.createMethodParams);

                await store.dispatch('payments/saveMethod', {
                    name: this.createMethodParams.name,
                    minimum_amount: this.createMethodParams.minimum,
                    tipalti: this.createMethodParams.tipalti,
                    is_on_dashboard_enabled: this.createMethodParams.is_on_dashboard_enabled,
                    is_on_funnel_enabled: this.createMethodParams.is_on_funnel_enabled,
                });

                this.dialog = !this.dialog
                this.createMethodParams = {
                    name: '',
                    minimum: '',
                    tipalti: true,
                };
                this.loading = false;

                this.ALERT_SUCCESS('Method was created 👍');
                setTimeout(() => {
                    this.ALERT_SUCCESS('');
                }, 3500)
                this.$emit('created');
            },
        },
        watch: {
            dialog() {
                this.$emit('toggle', this.dialog);
            },
            open() {
                this.dialog = this.open
            },
        },
    }
</script>

<style scoped lang="sass">
    .modal_background 
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        background-color: rgba(0, 0, 0, 0.5)
        display: flex
        justify-content: center
        align-items: center

    .modal_add_methods_wrap 
        background-color: white
        padding: 20px
        border-radius: 10px
        min-height: 400px
        min-width: 600px
        z-index: 100000
    .flex-column 
        display: flex
        flex-direction: column
        padding: 20px 
    .header
        text-align: center
    .button-row 
        display: flex
        justify-content: space-between
               
</style>
